import { IconChevronsLeft, IconChevronsRight } from "@/assets/icons";
import { black, blue, text } from "@/theme/colors";
import { typography } from "@/theme/typography";
import { isNumber } from "@/utils/number";
import { Pagination as MuiPagination, PaginationItem, Stack, styled } from "@mui/material";
import { FC, useEffect, useState } from "react";

type TFeaturePaginationProps = {
  page: number;
  totalPage: number;
  onChange: (page: number) => void;
};

export const FeaturePagination: FC<TFeaturePaginationProps> = ({ page, totalPage, onChange }) => {
  const [displayTotalPage, setDisplayTotalPage] = useState<number>(1);

  useEffect(() => {
    if (isNumber(totalPage)) {
      setDisplayTotalPage(totalPage > 0 ? totalPage : 1);
    }
  }, [totalPage]);

  return (
    <Stack direction="row" alignItems="center">
      <StyledPagination
        page={page}
        count={displayTotalPage}
        variant="outlined"
        shape="rounded"
        showFirstButton
        showLastButton
        renderItem={(item) => <PaginationItem slots={{ first: IconChevronsLeft, last: IconChevronsRight }} {...item} />}
        onChange={(_, value) => onChange(value)}
      />
    </Stack>
  );
};

const StyledPagination = styled(MuiPagination)(() => ({
  "& .MuiPaginationItem-root": {
    border: "1px solid #CACDCD",
    borderRadius: 8,
    minWidth: 40,
    height: 40,
    ...typography.body14Semi,
    color: `${black[70]}`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxSizing: "border-box",
  },
  "& .MuiPaginationItem-root.Mui-selected": {
    backgroundColor: `${blue[80]}`,
    color: `${text.white}`,
    border: "none",
    "&:hover": {
      backgroundColor: `${blue[80]}`,
    },
  },
  "& .MuiPaginationItem-ellipsis": {
    border: "1px solid transparent",
    minWidth: 40,
    height: 40,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    lineHeight: 1,
    fontWeight: 500,
    color: `${black[70]}`,
  },
  "& .MuiPaginationItem-root.Mui-disabled": {
    minWidth: 40,
    height: 40,
    border: "1px solid transparent",
    backgroundColor: `${black[99]}`,
    color: `${black[70]}`,
    pointerEvents: "none",
  },
}));
